<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-06 17:24:13
 * @FilePath: \mrc-base-frontend\src\views\pushMessageTemplate\addMessageTemplate.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-10 16:50:28
-->
<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">{{
        $t("label_The_general_information")
      }}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">{{
        $t("label_The_template")
      }}</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <commoninfor @changee1="changee1"></commoninfor>
      </v-stepper-content>

      <v-stepper-content step="2">
        <langTemplate
          @changee1="changee2"
          :commoninforloading="loading"
          @submit="submit"
        ></langTemplate>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
import commoninfor from "./modules/commoninfor";
import langTemplate from "./modules/langTemplate";
import { addMessageTemplateDetail } from "@/service/api/pushMessageTemplate";

export default {
  components: {
    commoninfor,
    langTemplate,
  },
  data() {
    return {
      loading: false,
      e1: 1,
      addlist: {}, //一般资料
      addlist2: {}, //模板
    };
  },
  mounted() {},
  methods: {
    changee2(num, val1) {
      this.e1 = num;
    },
    changee1(num, val1) {
      this.e1 = num;
      val1 ? (this.addlist = val1) : "";
    },
    async submit(val) {
      this.loading = true;
      await addMessageTemplateDetail(
        Object.assign(this.addlist, {
          mrbase_sys_message_push_template_language: this.$clone(val),
        })
      ).then((res) => {
        if (res.code == 200) {
          this.$Message({ text: this.$t("message_added_successfully") });
          this.$router.push({
            name: "pushMessageTemplate",
          });
        }
      });
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.v-stepper__content {
  padding: 0px 0px;
}
</style>